(function(d){

  qsa('.slider').map(function(el){ return new Slider(el) })

  function Slider(el) {

    var slides = qsa('.slide', el).map(function(el){ return new Slide(el) }),
        count = slides.length,
        last = count - 1,
        prevBtn = el.querySelector('.prev'),
        nextBtn = el.querySelector('.next'),
        navBtns = el.querySelector('.bullets'),
        btns = qsa('.bullet', navBtns),
        play = el.classList.contains('play'),
        clicklimit = el.classList.contains('clicklimit'),
        cur = 0,
        old = 0,
        timeout,
        an

    goTo(0)

    if(count > 1)
    {
      on(prevBtn, 'click', prev)
      on(nextBtn, 'click', next)
      on(navBtns, 'click', nav)
      el.classList.add('loaded')
    }

    function goTo(i, rev) {
      if(clicklimit && slides[cur].isAn()) return
      slides[old].reset()
      slides[cur].set(true, rev)
      slides[i].set(false, rev)
      updateBtns(cur, i)
      old = cur
      cur = i
      que()
      if(an) el.classList.add('an')
      an = true
    }

    function prev() {
      goTo(cur > 0 ? cur - 1 : last, 1)
    }

    function next() {
      goTo(cur < last ? cur + 1 : 0)
    }

    function nav(e) {
      if(e.target != this) {
        var i = index(e.target)
        goTo(i, i < cur)
      }
    }

    function updateBtns(cur, next) {
      if(btns[cur]) btns[cur].classList.remove('active')
      if(btns[next]) btns[next].classList.add('active')
    }

    function que() {
      if(timeout) clearTimeout(timeout)
      if(play && count > 1) timeout = setTimeout(next, 6000)
    }
  }

  function Slide(el) {
    var c, an

    this.set = function(isOut, isReverse) {
      this.reset()
      c = (isOut ? 'out-':'in-') + (isReverse ? 'backward':'forward')
      el.classList.add(c)
    }

    this.reset = function() {
      if(c) el.classList.remove(c)
      c = null
    }

    this.isAn = function() {
      return an
    }

    on(el, 'animationstart', function(){ an = true })
    on(el, 'animationend', function(){ an = false })

  }

  function on(el, ev, fn) {
    if(el) el.addEventListener(ev, fn, false);
  }
  function qsa(q, c) {
    return Array.prototype.slice.call((c||d).querySelectorAll(q))
  }
  function index(node) {
    return [].indexOf.call(node.parentNode.children, node)
  }

})(document);
